import { Modal as AntdModal } from 'antd';
import styled, { DefaultTheme, css } from 'styled-components';

type SpacedItemsSectionProps = {
  marginTop?: string;
};

type TextProps = {
  size?: 'small' | 'medium' | 'large';
  fontWeight?: number;
  color: keyof DefaultTheme['colors'];
} & SpacedItemsSectionProps;

const textModifiers = {
  small: css`
    font-size: 1.4rem;
    line-height: 2.2rem;
  `,
  medium: css`
    font-size: 1.6rem;
    line-height: 2.6rem;
  `,
  large: css`
    font-size: 1.8rem;
    line-height: 2.8rem;

    @media (max-width: 992px) {
      font-size: 1.4rem;
      line-height: 2.2rem;
    }
  `,
};

export const Text = styled.p<TextProps>`
  ${({
    theme,
    size = 'medium',
    color = 'neutralSilver60',
    fontWeight = 500,
    marginTop,
  }) => css`
    color: ${theme.colors[color]};
    font-weight: ${fontWeight};
    margin-top: ${marginTop};
    ${textModifiers[size]}
  `}
`;

export const Modal = styled(AntdModal)`
  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-modal-body {
    padding: 16px 0 0 0;
  }

  .ant-modal-close {
    top: 40px;
    right: 24px;

    @media (max-width: 992px) {
      top: 16px;
      right: 16px;
    }
  }

  .ant-modal-close-x {
    width: 44px;
    height: 44px;

    @media (max-width: 992px) {
      width: 48px;
      height: 48px;
    }
  }
`;

export const ChancesSection = styled.section`
  padding: 28px 40px 24px;

  @media (max-width: 992px) {
    padding: 8px 24px 24px;
  }

  @media (max-width: 768px) {
    button {
      width: 100%;
      justify-content: center;
    }
  }
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.colors.neutralSilver90};
    font-size: 2.4rem;
    line-height: 2.8rem;
    font-weight: 600;
    margin-bottom: 12px;

    @media (max-width: 992px) {
      font-size: 1.6rem;
      line-height: 2.2rem;
      margin-top: 8px;
    }
  `}
`;

export const CloseButton = styled.div`
  ${({ theme }) => css`
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.neutralSilver5};
    border-radius: 50%;
    border: 0;
    margin: 0;
    cursor: pointer;

    @media (max-width: 992px) {
      width: 48px;
      height: 48px;

      svg {
        width: 24px;
        height: 24px;
      }
    }
  `}
`;

export const SpacedItemsSection = styled.div<SpacedItemsSectionProps>`
  ${({ marginTop }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 24px;
    row-gap: 8px;

    margin-top: ${marginTop};
  `}
`;

export const CenteredSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
`;

export const ExploreMoreSection = styled.section`
  ${({ theme }) => css`
    background: ${theme.colors.neutralSilver5};
    padding: 28px 40px 46px;
    border-top: 1px solid ${theme.colors.neutralSilver10};
    border-radius: 0 0 8px 8px;
  `}
`;

export const CarouselContainer = styled.div`
  margin-top: 30px;

  @media (max-width: 992px) {
    margin-top: 0;

    .slick-arrow {
      display: none !important;
    }
  }
`;

export const DesktopOnly = styled.div`
  display: block;

  @media (max-width: 992px) {
    display: none;
    border-radius: 0 0 8px 8px;
  }
`;

export const MobileOnly = styled.div`
  display: block;

  @media (min-width: 992px) {
    display: none;
  }
`;

export const CollapseContainer = styled.div`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.neutralSilver30};

    .ant-collapse {
      border-radius: 0 0 8px 8px;
    }

    .ant-collapse-content-box {
      padding: 0;
    }
  `}
`;

export const ContentBoxImage = styled.img.attrs({
  alt: '',
})`
  width: 30px;
  height: 30px;
`;

export const TooltipContainer = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  z-index: 1;
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;
  position: absolute;
  right: -40px;
  z-index: 2;

  @media (max-width: 992px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    width: 48px;
  }
`;
